import { Localization } from '@aa-app-localization'
import { ImageFragment, NewsCategoryEnum } from '@app-graphql/schema'

export type ContentSearchInput = {
    query?: string
    locale: Localization.Locale
    page?: number
    perPage?: number
}

export type NewsOverviewInput = {
    locale: Localization.Locale
    category?: NewsCategoryEnum
    page?: number
    perPage?: number
}

export type PageSearchHit = {
    slug: string
    locale: string
    title?: string | null
    metaTitle?: string | null
    metaDescription?: string | null
}

export type NewsSearchHit = {
    slug: string
    locale: string
    title?: string | null
    description?: string | null
    category?: string | null
    metaTitle?: string | null
    metaDescription?: string | null
    image?: ImageFragment | null
    publishedAt?: string | null
}

export type PageSearchResult = {
    hits: PageSearchHit[]
    totalHits: number
    page: number
    perPage: number
    totalPages: number
    processingTimeMs: number
}

export type NewsSearchResult = {
    hits: NewsSearchHit[]
    totalHits: number
    page: number
    perPage: number
    totalPages: number
    processingTimeMs: number
}

export type ContentSearchResult = {
    hits: Array<{ hit: PageSearchHit | NewsSearchHit; type: 'page' | 'news-item' }>
    totalHits: number
    page: number
    perPage: number
    totalPages: number
    processingTimeMs: number
}

export const PAGE_SEARCH_QUERY = `
query PageSearch($input: PageSearchInput!) {
  pageSearch(input: $input) {
    hits { slug locale title metaTitle metaDescription }
    totalHits page perPage totalPages processingTimeMs
  }
}`

export const NEWS_OVERVIEW_QUERY = `
query NewsOverview($input: NewsSearchInput!) {
  newsSearch(input: $input) {
    hits {
      slug locale title description category publishedAt
      image { __typename name caption width height provider previewUrl url alt }
    }
    totalHits page perPage totalPages processingTimeMs
  }
}`

export const NEWS_SEARCH_QUERY = `
query NewsSearch($input: NewsSearchInput!) {
  newsSearch(input: $input) {
    hits { slug locale title description category metaTitle metaDescription }
    totalHits page perPage totalPages processingTimeMs
  }
}`
